import * as Yup from 'yup';

// The FE password rule for this app's own screens. The minimum matches the
// backend (coral-platform apps/backend/src/common/validation/password.ts, which
// enforces length only); the composition rules below are this app's additional
// requirement. A password accepted here therefore always satisfies the API,
// and any published baseline credential has to clear both rule sets.
export const PASSWORD_MIN_LENGTH = 10;

// Returns a Yup string schema for a user-chosen password.
// Pass the i18next `t` if you want the "required" message translated;
// otherwise it falls back to a plain English string.
export const buildPasswordSchema = (t) =>
  Yup.string()
    .matches(/\w*[a-z]\w*/, 'Password must have a small letter')
    .matches(/\w*[A-Z]\w*/, 'Password must have a capital letter')
    .matches(/\d/, 'Password must have a number')
    .matches(
      /[!@#$%^&*()\-_"=+{}; :,<.>]/,
      'Password must have a special character'
    )
    .min(
      PASSWORD_MIN_LENGTH,
      ({ min }) => `Password must be at least ${min} characters`
    )
    .required(t ? t('passwordRequired') : 'Password is required');
